import { Component, EventEmitter, Input, Output, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { DndDropEvent, DndModule } from 'ngx-drag-drop';
import { Question } from '../../../models/QuestionResponse';

class SentenceItem {
  sentence: string;
  dynamic: boolean;

  constructor(sentence: string, dynamic: boolean) {
    this.sentence = sentence;
    this.dynamic = dynamic;
  }
}

@Component({
  selector: 'q-trous',
  standalone: true,
  imports: [DndModule],
  templateUrl: './trous.component.html',
  styleUrl: './trous.component.scss',
})
export class TrousComponent implements AfterViewInit {
  @Input() question!: Question;
  @Input() pickedAnswer!: string;
  @Output() pickedAnswerChange = new EventEmitter<string>();

  answers: SentenceItem[] = [];
  possibleChoices: string[] = [];
  bounceIndex: number = -1;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.setupQuestion();
  }

  ngAfterViewInit() {
    // Emit initial value after view is initialized to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.updateSentence();
    }, 0);
  }

  setupQuestion() {
    const sentenceIndex = this.question.answers.findIndex((elt) => elt.includes('............'));
    const parts = this.question.answers[sentenceIndex].split('............');
    const result: SentenceItem[] = [];
    for (let i = 0; i < parts.length; i++) {
      result.push(new SentenceItem(parts[i].trim(), false));
      if (i < parts.length - 1) {
        result.push(new SentenceItem('............', true));
      }
    }

    this.answers = result;
    this.possibleChoices = [...this.question.good_answers];
    // Don't call updateSentence here to avoid ExpressionChangedAfterItHasBeenCheckedError
  }

  resetQuestion() {
    this.setupQuestion();
  }

  selectChoice(i: number) {
    if (this.isSelected(this.possibleChoices[i])) {
      return;
    }

    const index = this.answers.findIndex((elt) => elt.dynamic && elt.sentence === '............');

    if (index !== -1) {
      this.answers[index].sentence = this.possibleChoices[i];

      // Trigger bounce animation
      this.bounceIndex = index;
      this.cdr.detectChanges(); // Force change detection
      setTimeout(() => {
        this.bounceIndex = -1;
        this.cdr.detectChanges(); // Force change detection
      }, 300);
    }

    this.updateSentence();
  }

  unselectChoice(i: number) {
    if (!this.answers[i].dynamic) {
      return;
    }

    this.answers[i].sentence = '............';
    this.updateSentence();
  }

  updateSentence() {
    const sentenceIndex = this.question.answers.findIndex((elt) => elt !== '' && elt.includes('............'));
    let sentence = this.question.answers[sentenceIndex];
    const parts = this.answers.filter((elt) => elt.dynamic);
    for (let i = 0; i <= parts.length - 1; i++) {
      sentence = sentence.replace('............', parts[i].sentence);
    }

    this.pickedAnswer = sentence;
    this.pickedAnswerChange.emit(this.pickedAnswer);
  }

  isSelected(answer: string): boolean {
    return this.answers.findIndex((elt) => elt.sentence === answer) !== -1;
  }

  isFilled(index: number): boolean {
    return this.answers[index].dynamic && this.answers[index].sentence !== '............';
  }

  shouldBounce(index: number): boolean {
    return this.bounceIndex === index;
  }
}
